import React from 'react';
import { Row, Col, Alert, Button, ButtonToolbar, FormControl, FormGroup } from 'react-bootstrap';
import DropDownInput from './common/DropDownInput.jsx';

export default class DownloadMPhotosComponent extends React.Component {

  componentDidMount() {
    this.props.findAllOrderIds();
  }

  componentWillUnmount() {
    this.props.cleanAlert();
  }

  render() {

    let generateMPhotosFile = () => {
      this.props.generateMPhotosFile(this.props.formBean);
    };

    let generateMCasesFile = () => {
      this.props.generateMCasesFile(this.props.formBean);
    };

    let downloadLinkStyle = {
      display: !this.props.formBean.get('outputFile') ? 'none' : 'block'
    };

    let openPdf = () => {
      window.open(this.props.formBean.get('outputFile'));
    };

    let downloadLinkStyle2 = {
      display: !this.props.formBean.get('outputFile2') ? 'none' : 'block'
    };

    let openPdf2 = () => {
      window.open(this.props.formBean.get('outputFile2'));
    };

    // 新北市
    let generateMCasesFileNtpc = () => {
      this.props.generateMCasesFileNtpc(this.props.formBean, this.uploadFileNtpc);
    };
    let downloadLinkStyleNtpc = {
      display: !this.props.formBean.get('outputFileNtpc') ? 'none' : 'block'
    };
    let openPdfNtpc = () => {
      window.open(this.props.formBean.get('outputFileNtpc'));
    };

    // 建議不再使用
    let generateDiscardList = () => {
      this.props.generateDiscardList(this.props.formBean);
    };
    let downloadLinkStyleDiscard = {
      display: !this.props.formBean.get('outputFileDiscard') ? 'none' : 'block'
    };
    let openPdfDiscard = () => {
      window.open(this.props.formBean.get('outputFileDiscard'));
    };

    let alertDiv = null;
    if (this.props.alertStyle || this.props.alertMessage) {
      alertDiv = (
        <Alert bsStyle={this.props.alertStyle} onDismiss={this.props.cleanAlert}>
          {this.props.alertMessage}
        </Alert>
      );
    }

    return (
      <div>
        <h4>下載清洗資料</h4>
        <Row>
          <Col xs={12} sm={6} md={6}>
            {alertDiv}
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12} sm={6} md={6}>
            <DropDownInput id="orderId"
              label="清洗維修標案"
              required="true"
              options={this.props.allMOrders.map((value, key) => ({ label: value.get('display'), value: value.get('order_id') })).toJS()}
              onChange={(id, value, label) => {
                this.props.setValue(id, value);
                this.props.findMCasesDropDownMenu(value);
              }}
              validation={this.props.formBeanValidation.get('orderId')}
            />
            <DropDownInput id="caseId"
              label="清點作業"
              required="true"
              options={this.props.allMCasesByOrder.map((value, key) => ({ label: value.get('note') + ' (' + value.get('status_display') + ')', value: value.get('case_id') })).toJS()}
              onChange={(id, value, label) => {
                this.props.setValue(id, value);
              }}
              validation={this.props.formBeanValidation.get('caseId')}
            />
            <a href="doc/mcase-upload-download.html" target="_blank">
              <img src='question.svg' height="20" width="20" alt="" />說明
            </a>
          </Col>
        </Row>
        <Row>
          <hr style={{ border: 'none', borderTop: '1px solid #aaa' }} />
          <Col xs={12} sm={12} md={12}>
            <ButtonToolbar>
              <Button bsStyle="info" onClick={generateMPhotosFile}>取得清洗維修照片</Button>
              <Button style={downloadLinkStyle} bsStyle="default" onClick={openPdf}>下載清洗維修照片</Button>
            </ButtonToolbar>
          </Col>
        </Row>
        <Row>
          <hr style={{ border: 'none', borderTop: '1px solid #aaa' }} />
          <Col xs={12} sm={6} md={6}>
            <b>1) 不上傳比對檔案，下載完整資料</b><br />
            <br />
            <ButtonToolbar>
              <Button bsStyle="info" onClick={generateMCasesFile}>取得清洗維修檔案</Button>
              <Button style={downloadLinkStyle2} bsStyle="default" onClick={openPdf2}>下載清洗維修檔案</Button>
            </ButtonToolbar>
          </Col>
        </Row>
        <Row>
          <hr style={{ border: 'none', borderTop: '1px solid #aaa' }} />
          <Col xs={12} sm={12} md={12}>
            <b>2) 上傳原新北消防局檔案，進行比對下載符合資料</b><br />
            <br />
            <FormGroup controlId="ntpc_upload" >
              <FormControl
                type="file"
                onChange={(event) => {
                  this.uploadFileNtpc = event.target.files[0];
                }}
              />
            </FormGroup>
          </Col>
          <Col xs={12} sm={12} md={12}>
            <ButtonToolbar>
              <Button bsStyle="info" onClick={generateMCasesFileNtpc}>取得清洗維修檔案</Button>
              <Button style={downloadLinkStyleNtpc} bsStyle="default" onClick={openPdfNtpc}>下載清洗維修檔案</Button>
            </ButtonToolbar>
            <br /><b>注意：僅會比對維護序號然後更新檔案資料，維護序號不存在則不會更新，且不一定為該清點作業完整資料</b>
          </Col>
        </Row>
        <Row>
          <hr style={{ border: 'none', borderTop: '1px solid #aaa' }} />
          <Col xs={12} sm={12} md={12}>
            <ButtonToolbar>
              <Button bsStyle="info" onClick={generateDiscardList}>取得建議不再使用名單</Button>
              <Button style={downloadLinkStyleDiscard} bsStyle="default" onClick={openPdfDiscard}>下載建議不再使用名單</Button>
            </ButtonToolbar>
            <br /><b>可不選「清點作業」，一次下載整批「清洗維修標案」</b>
          </Col>
        </Row>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/DownloadMPhotosComponent.jsx